import React, { Component } from 'react'
import PropTypes from 'prop-types'
import toCssClasses, { prefixClass } from './toCssClasses'
import toCssClassesv2 from './toCssClassesv2'
import grid from './grid.module.css'

class Col extends Component {

   makeFullClasses() {
        let classes = []
        classes.push(grid.col)
        
        const { size, order, alignSelf, grow, text, hidden, float, flex, justifyContent, alignItems, className } = this.props
        
        if(flex)
        classes.push(grid.flex)

        if(size) {
            if(size.split(' ').length > 3)
                classes = toCssClasses(size, 'col', classes)
            else
                classes = toCssClassesv2(size, 'col', classes)
        }

        if(alignSelf)
        classes = toCssClasses(alignSelf, 'align-self', classes)

        if(order)
        classes = toCssClasses(order, 'order', classes)

        if(text)
        classes = toCssClasses(text, 'text', classes)

        if(hidden)
        classes = prefixClass(hidden, 'hidden', classes)

        if(float)
        classes = prefixClass(float, 'float', classes)

        if(grow)
        classes = toCssClassesv2(grow, 'grow', classes)

        if(justifyContent)
        classes = toCssClasses(justifyContent, 'justify-content', classes)

        if(alignItems)
        classes = toCssClasses(alignItems, 'align-items', classes)

        if(className)
        classes.push(className)

        return classes.join(' ')
   }

   render() {
        const { style = {}, spacing } = this.props

        if(spacing)
        style.marginBottom = `${spacing * 30}px`

        return (
            <div ref='div' className={this.makeFullClasses()} style={{ ...style }}>
                {this.props.children}
            </div>
        )
   }
}

Col.propTypes = {
   size: PropTypes.string,
   order: PropTypes.string,
   text: PropTypes.string,
   hidden: PropTypes.string,
   justifyContent: PropTypes.string,
   alignItems: PropTypes.string,
   flex: PropTypes.bool,
}

export default Col


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Grid/Col.js